function isPlainObject(x) {
  return x !== null && typeof x === 'object' && !Array.isArray(x);
}

/**
 * Deep merge `source` into `target`.
 * - Plain objects merge recursively
 * - Arrays/primitives/null/undefined override
 * - Skips `null` to avoid wiping defaults (optional; remove if you want null to override)
 */
export function deepMerge(target, source) {
  const out = { ...target };
  if (!isPlainObject(source)) return out;

  for (const [key, value] of Object.entries(source)) {
    if (value === null) continue;
    if (isPlainObject(value) && isPlainObject(out[key])) {
      out[key] = deepMerge(out[key], value);
    } else {
      out[key] = value;
    }
  }
  return out;
}

export function deepMergeAll(...sources) {
  return sources.reduce((acc, source) => deepMerge(acc, source), {});
}
